import type {
  CallLogCategoryType,
  CallLogDirectionType,
  CallLogDispositionType,
} from './types';
import emptyCallLogsSrc from 'Assets/images/empy-states/empty-call-logs.png?inline';
import IncomingCallIcon from 'Assets/images/incoming-call.svg';
import MissedCallIcon from 'Assets/images/missed-call.svg';
import OutgoingCallIcon from 'Assets/images/outgoing-call.svg';
import React from 'react';
import { EmptyState } from '~/lib/ui/emptyState';

export const TYPES_OF_CALLS: CallLogCategoryType[] = [
  'missed',
  'incoming',
  'outgoing',
  'all',
];

export type CallsTypesContentProps = {
  [prop in CallLogCategoryType]: {
    title: string;
    placeholder: string;
    emptySearchText: React.ReactNode;
    direction: CallLogDirectionType;
    disposition: CallLogDispositionType;
  };
};

export const CALL_TYPES_CONTENT: CallsTypesContentProps = {
  missed: {
    title: 'Missed calls',
    placeholder: 'Search missed calls',
    emptySearchText: <div>Way to go! You haven&apos;t missed any call!</div>,
    direction: 'inbound',
    disposition: 'missed',
  },
  incoming: {
    title: 'Incoming calls',
    placeholder: 'Search incoming call records',
    emptySearchText: <div>Bummer... You haven&apos;t received any call yet.</div>,
    direction: 'inbound',
    disposition: 'answered',
  },
  outgoing: {
    title: 'Outgoing calls',
    placeholder: 'Search outgoing call records',
    emptySearchText: (
      <>
        <div>This page is empty because you haven&apos;t called anyone yet.</div>
        <div>Go to your contacts list and call someone, anyone!</div>
      </>
    ),
    direction: 'outbound',
    disposition: null,
  },
  all: {
    title: 'All recent calls',
    placeholder: 'Search all call records',
    emptySearchText: (
      <EmptyState
        illustration={
          <img
            src={emptyCallLogsSrc}
            alt=""
            aria-hidden
            width={179.51}
          />
        }
        title="Your call history is clear"
        description={`Looks like you haven't made or received any calls yet.\nWhen you do, they'll show up right here.`}
        descriptionClassName="whitespace-pre-line"
      />
    ),
    direction: null,
    disposition: null,
  },
};

export const DIRECTIONS = {
  inbound_missed: 'missed',
  inbound_busy: 'incoming',
  inbound_answered: 'incoming',
  inbound_cancel: 'incoming',
  outbound_missed: 'outgoing',
  outbound_busy: 'outgoing',
  outbound_answered: 'outgoing',
  outbound_cancel: 'outgoing',
};

export const CALL_LOG_IMAGES = {
  missed: MissedCallIcon,
  incoming: IncomingCallIcon,
  outgoing: OutgoingCallIcon,
};

export const CALL_LOGS_PER_PAGE = 20;
